import getApiClient from '@/plugins/api-client'
import Vue from 'vue'

export default {
  save () {
    this.errors = {}
    const api = getApiClient(this.$store)

    api.post('user/admin/register', this.user)
      .then(result => {
        this.user = result.data
        this.$store.commit('app/raiseSuccess', 'Administrador adicionado com sucesso')
        this.$router.push({
          name: 'Users',
        })
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao adicionar administrador')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },
}
